import ScrollMagic from 'scrollmagic';

const videoBannerSelector = '#video-banner';

class VideoBanner {
  constructor() {
    this.controller = new ScrollMagic.Controller();
    this.isPlaying = true;
    this.videoEl = document.querySelector('#video-banner-background video');
    this.pauseButton = document.querySelector(
      '[aria-controls=video-banner-background]'
    );

    // Static video will not initialise ScrollMagic scene and make it fixed.
    const staticVideo = document
      .querySelector('#video-banner-background')
      .hasAttribute('data-static');

    if (!staticVideo) this.setupScenes();

    this.setupEvents();
  }

  setupScenes() {
    const bannerHeight = document
      .querySelector(videoBannerSelector)
      .getBoundingClientRect().height;
    const duration =
      bannerHeight -
      document.querySelector('.c-nav-primary').getBoundingClientRect().height;

    const navScene = new ScrollMagic.Scene({
      triggerElement: videoBannerSelector,
      duration: duration,
      triggerHook: 'onLeave',
    }).setClassToggle('.c-nav', 'c-nav--transparent');

    const videoScene = new ScrollMagic.Scene({
      triggerElement: videoBannerSelector,
      duration: bannerHeight,
      triggerHook: 'onEnter',
    })
      .setClassToggle('#video-banner-background', 'c-banner__background--fixed')
      .on('leave', this.handleVideoLeave);

    this.controller.addScene(navScene).addScene(videoScene);
  }

  handleVideoLeave(event) {
    document
      .querySelector('#video-banner-background')
      .classList.toggle(
        'c-banner__background--bottom',
        event.state === 'AFTER'
      );
  }

  setupEvents() {
    this.pauseButton.addEventListener(
      'click',
      this.handlePauseButton.bind(this)
    );
  }

  handlePauseButton() {
    this.isPlaying = !this.isPlaying;
    if (this.isPlaying) {
      this.videoEl.play();
    } else {
      this.videoEl.pause();
    }

    this.pauseButton.setAttribute('aria-pressed', !this.isPlaying);
  }
}

if (document.querySelector(videoBannerSelector)) {
  new VideoBanner();
}
